module.exports = `${require.publicPath}login-bg.59d3ab6a.png`;